export const arrowSubdirectory = {
  name: "arrow-subdirectory" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5 6.1a.9.9 0 0 1 .9.9v4.5a.1.1 0 0 0 .1.1h10.327l-2.463-2.464a.9.9 0 1 1 1.272-1.272l4 4a.9.9 0 0 1 0 1.272l-4 4a.9.9 0 0 1-1.272-1.272l2.463-2.464H6a1.9 1.9 0 0 1-1.9-1.9V7a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["arrow-subdirectory"],
  category: "utility" as const,
};
